import React from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

export default function SaveToCatalogDialog({ catSave, categories, confirmSaveToCatalog, setCatSave }) {
  return (
    <Dialog open={!!catSave} onOpenChange={(v) => { if (!v) setCatSave(null); }}>
      <DialogContent className="max-w-md" data-testid="save-to-catalog-dialog">
        <DialogHeader>
          <DialogTitle>Salva nel Listino</DialogTitle>
          <DialogDescription>
            Scrivi la categoria in cui salvare {catSave?.kind === "group" ? "questo gruppo di pacchetti" : "questo servizio"}. Verrà copiato come voce riutilizzabile.
          </DialogDescription>
        </DialogHeader>
        {catSave && (
          <div className="space-y-4">
            <div className="rounded-lg bg-slate-50 border border-slate-200 px-3 py-2">
              <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Elemento</p>
              <p className="font-semibold text-slate-900 text-sm">{catSave.title || "(senza titolo)"}</p>
            </div>
            <div>
              <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Categoria</Label>
              <Input data-testid="save-to-catalog-category" list="catalog-category-suggestions" className="mt-1.5" maxLength={60}
                value={catSave.category || ""} placeholder="Scrivi o scegli una categoria"
                onChange={(e) => setCatSave((s) => ({ ...s, category: e.target.value }))} />
              <datalist id="catalog-category-suggestions">
                {categories.map((c) => <option key={c.id} value={c.name} />)}
              </datalist>
              <p className="text-xs text-slate-500 mt-1">Se la categoria non esiste viene creata nel Listino.</p>
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => setCatSave(null)}>Annulla</Button>
          <Button data-testid="save-to-catalog-confirm" onClick={confirmSaveToCatalog}>Salva nel Listino</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
